import React from "react";
import "./customcheckbox.scss";
import { Form } from "react-bootstrap";

const CustomCheckbox = (props) => {
  return (
    <>
      <Form.Check
        defaultChecked={props.defaultChecked}
        checked={props.checked}
        type={props.type === "checkbox" ? "checkbox" : "radio"}
        name={props.name}
        id={props.potId}
        label={props.label}
        className={props.variantName}
        onChange={props.onChange}
        aria-label={
          props.name
            ? `${props.name} checkbox`
            : props.label
              ? `${props.label} checkbox`
              : "checkbox"
        }
      />
    </>
  );
};

export default CustomCheckbox;
